import { useRef, useEffect } from 'react'

import styles from './decoration.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'

import classNames from 'classnames'


function Decoration(props) {
	const ref = useRef(null)
	// const backgroundTransitionColorRef = useRef(null)
	let fields = props.fields

	useEffect(() => {

		const onScroll = () => {
			const topPos = ref.current.getBoundingClientRect().top
			const scrollPos = window.scrollY + window.innerHeight

			if (fields.background_transition_color) {
				let top = ref.current.getBoundingClientRect().top

				if (top < 0 && Math.abs(top) < fields.background_transition_height) {
					// top = Math.abs(top)
					// top = Math.min(top, 600)
					// const progress = top / 600
					document.body.style.backgroundColor = fields.background_transition_color
					// backgroundTransitionColorRef.current.style.opacity = 1
				} else {
					document.body.style.backgroundColor = 'white'
					// backgroundTransitionColorRef.current.style.opacity = 0
				}
			}

			ref.current.style.transform = 'translateY(' + topPos*.2 + 'px)'
		}
		
		onScroll()

		window.addEventListener('scroll', onScroll)
		return () => window.removeEventListener('scroll', onScroll)
	}, [])

	return <div ref={ref} className={styles.decoration} style={{marginTop: !fields.image && fields.margin_top ? fields.margin_top : ''}}>
		<BlockWrapper {...props} className={classNames(styles.decoration_wrapper, fields.background_transition_color ? styles.background_transition_wrapper : '')}>
			{fields.image && <Image {...fields.image} className={styles.image} style={{marginTop: fields.margin_top ? fields.margin_top : ''}} />}
			{/* {fields.background_transition_color && <div ref={backgroundTransitionColorRef} className={styles.background_transition_color} style={{backgroundColor: fields.background_transition_color, height: fields.background_transition_height}} />} */}
		</BlockWrapper>
	</div>
}

export default Decoration